import React from 'react'
import { useState } from "react";
import { useDispatch } from 'react-redux';
import "../chatAiComponents/ChatAii.css";

import { Fragment} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline'

import { Receipt, Bell, People, Sliders, Calendar3, UsbSymbol, Calendar2Check, Person } from "react-bootstrap-icons";
import Sidebar from './StartedSidebar';

import GettingStarted from './GettingStarted';
import Introduction from './Introduction';
import LeadMangement from './LeadMangement';
// import ChatSettings from './ChatSettings';

const StartedComponent = (props) => {
  const dispatch = useDispatch();
  // const operation_mode = useSelector((state) => state.chatAi.operation_mode);
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const navigation = [
    { name: 'Getting Started', href: '/Started', icon: "", current: "getting" , nav_name: "getting" },
    // { name: 'Introduction', href: '/Started/introduction', icon: Person, current: "introduction" , nav_name: "introduction" },
    { name: 'Set Signals', href: '/Started/introduction', icon: "", current: "introduction" , nav_name: "introduction" },
    { name: 'Lead Mangement', href: '/Started/leadMangement', icon: "", current: "leadMangement" , nav_name: "leadMangement" },
  ]
  

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  
  const RightScreen = () => {
    if (props.subPageName === "getting") {
      return <GettingStarted authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "introduction") {
      return <Introduction authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else if (props.subPageName === "leadMangement") {
      return <LeadMangement authToken={props.authToken} pageName={props.pageName} subPageName={props.subPageName}/>
    }
    else {
      return
    }
  }

  const userType = localStorage.getItem("userType")
    ? localStorage.getItem("userType")
    : ""; 

  return (
    <>
      <div className='h-full'>
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog as="div" className="relative z-50 lg:hidden" onClose={setSidebarOpen}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </Transition.Child>

            <div className="fixed inset-0 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button type="button" className="-m-2.5 p-2.5" onClick={() => setSidebarOpen(false)}>
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  {/* Sidebar component, swap this element with another sidebar if you like */}
                  <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                    <div className="flex h-16 shrink-0 items-center">
                    <div className='text-base font-[600] py-4 '>Train AI</div>
                    </div>
                    <nav className="flex flex-1 flex-col">
                      <ul role="list" className="flex flex-1 flex-col gap-y-7">
                        <li>
                          <ul role="list" className="-mx-2 space-y-1">
                            {navigation.map((item) => (
                              <li key={item.name}>
                                <span
                                  href={item.href}
                                  className={classNames(
                                    props.subPageName === item.current
                                      ? 'bg-gray-50 text-[var(--brand-primary)]'
                                      : 'text-[var(--brand-secondary)] hover:text-[var(--brand-primary)] hover:bg-gray-50',
                                    'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                                  )}
                                >
                                  <item.icon
                                    className={classNames(
                                      props.subPageName === item.current ? 'text-[var(--brand-primary)]' : 'text-gray-400 group-hover:text-[var(--brand-primary)]',
                                      'h-6 w-6 shrink-0'
                                    )}
                                    aria-hidden="true"
                                  />
                                  {item.name}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </li>
                        {/* <li>
                          <div className="text-xs font-semibold leading-6 text-gray-400">Your teams</div>
                        </li> */}
                      </ul>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
        {/* Static sidebar for desktop */}
        <Sidebar subPageName={props.subPageName} navigation={navigation}/>
        {/* Static sidebar for mobile */}
        <div className="lg:pl-72">
          <div className="sm:hidden hidden sticky top-0 z-40 h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
            <button type="button" className="-m-2.5 p-2.5 text-[var(--brand-secondary)] lg:hidden" onClick={() => setSidebarOpen(true)}>
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
            {/* Separator */}
          </div>
          <main className="pt-[5rem] pb-10 h-full bg-[#F3F4F6] border-l border-gray-200">
            <div className={(props.subPageName !== "calender" && props.subPageName !== "events" && props.subPageName !== "connect" && props.subPageName !== "eventSetting") && "px-6 sm:px-8 lg:px-10"}>
              <RightScreen pageName={props.pageName} subPageName={props.subPageName} authToken={ props.authToken } />
            </div>
          </main>
        </div>
      </div>
    </>
  )
}

export default StartedComponent
